import apiClient from "./axiosConfig";

/**
 * 查询用户的专家答疑列表（分页）--个人中心
 * @param {number} pageNum - 页码，默认1
 * @param {number} pageSize - 每页条数，默认10
 */
export function getExpertAnswerList(pageNum = 1, pageSize = 10) {
  return apiClient({
    url: "/interface/answerbox/list",
    method: "get",
    params: {
      pageNum,
      pageSize
    }
  });
}

/**
 * 查询用户的专家答疑列表（分页）--首页
 * @param {number} pageNum - 页码，默认1
 * @param {number} pageSize - 每页条数，默认10
 */
export function getallExpertAnswerList(pageNum = 1, pageSize = 10) {
  return apiClient({
    url: "/interface/answerbox/alllist",
    method: "get",
    params: {
      pageNum,
      pageSize
    }
  });
}
/**
 * 提交专家答疑问题
 */
export function submitExpertQuestion(question) {
  return apiClient({
    url: "/interface/answerbox/submit",
    method: "post",
    data: {
      question: question
    }
  });
}

/**
 * 获取专家答疑详情
 */
export function getExpertAnswerDetail(id) {
  return apiClient({
    url: `/interface/answerbox/${id}`,
    method: "get",
  });
}

/**
 * 获取未读回复数量
 */
export function getUnreadCount() {
  return apiClient({
    url: "/interface/answerbox/unread/count",
    method: "get",
  });
}

/**
 * 标记回复为已读
 */
export function markAsRead(id) {
  return apiClient({
    url: `/interface/answerbox/read/${id}`,
    method: "post",
  });
}
